import type { Department, JobsData } from '../_components/types';

export const parseListData = (
  data: JobsData | undefined,
): Department[] | undefined => {
  const departments = new Set<string>();
  if (!data || !Array.isArray(data.jobs)) return undefined;

  data.jobs.forEach((job) => {
    if (job.department) departments.add(job.department);
  });

  const sortedDepartments = Array.from(departments).sort((a, b) =>
    a.localeCompare(b),
  );
  const counts: Department[] = [];

  sortedDepartments.forEach((dept) => {
    counts.push({
      name: dept,
      count: data.jobs.filter((job) => job.department === dept).length,
    });
  });

  return counts;
};
